<template>
    <el-dialog
        class="attachment-view-dialog"
        :title="title"
        :visible.sync="openAttachmentDialog"
        width="700px"
        style="padding: 0 50px 50px 0;"
        :before-close="confirmDialog">
        <div class="dialog-body">
            <el-table
                :data="totalData"
                height="350"
                border
                style="width: 100%">
                <el-table-column v-for="(item, index) in config.column"
                                 show-overflow-tooltip
                                 :key="index"
                                 :prop="item.prop"
                                 :label="item.label"
                                 width="150">
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="217">
                    <template slot-scope="scope">
                        <span class="preview-btn" @click="handlePreview(scope.row)">预览</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirmDialog">确 定</el-button>
        </span>
        <preview
            :attachmentList="attachmentList"
            v-if='attachmentShow'
            :attachmentShow.sync='attachmentShow'
            :rowData='rowData'>
        </preview>
    </el-dialog>
</template>

<script>
import preview from './viewAttachment.vue';
import { getAttachment } from '../api/register/driver.js';

export default {
    name: 'AttachmentDialog',
    components: { preview },
    data() {
        return {
            attachmentShow: false,
            rowData: {},
            totalData: [],
            attachmentList: [],
            allAttachmentList: []
        };
    },
    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        },
        openAttachmentDialog: {
            type: Boolean,
            default() {
                return false;
            }
        },
        title: {
            type: String,
            default() {
                return '附件查看';
            }
        }
    },
    methods: {
        confirmDialog() {
            this.totalData = [];
            this.$emit('closeAttachmentDialog', false);
        },
        handlePreview(row) {
            this.rowData = {
                downUrl: row.temFileUrl || row.fileUrl,
                fileName: row.qualificationName,
                fileId: row.fileId
            };
            this.attachmentList = this.allAttachmentList;
            this.attachmentShow = true;
        },
        handleGetAllAttachment() {
            const list = [];
            this.totalData.forEach(e => {
                if (e.temFileUrl || e.fileUrl) {
                    list.push(e.temFileUrl || e.fileUrl);
                }
            });
            this.allAttachmentList = list.filter((item) => { if (item) return item; });
        }
    },
    watch: {
        config: {
            handler(nVal) {
                if (nVal.id) {
                    getAttachment(nVal.url, nVal.id).then(res => {
                        if (res && +res.code === 0) {
                            this.totalData = res.data;
                            this.handleGetAllAttachment();
                        }
                    });
                }
            },
            deep: true
        }
    }
};
</script>

<style lang="less">
    .attachment-view-dialog {
        .dialog-body {
            width: 100%;
            border: 1px solid #EBEEF5;
            .preview-btn {
                color: #33c9cc;
                cursor: pointer;
                text-decoration: underline;
                text-align: center;
            }
        }
    }

</style>
